var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFarFaBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6665 3.7015H13.1665V2.03483C13.1665 1.11566 12.419 0.368164 11.4998 0.368164H6.49984C5.58067 0.368164 4.83317 1.11566 4.83317 2.03483V3.7015H2.33317C1.414 3.7015 0.666504 4.449 0.666504 5.36816V14.5348C0.666504 15.454 1.414 16.2015 2.33317 16.2015H15.6665C16.5857 16.2015 17.3332 15.454 17.3332 14.5348V5.36816C17.3332 4.449 16.5857 3.7015 15.6665 3.7015ZM11.4998 2.03516V3.70182H6.49976V2.03516H11.4998ZM5.6665 5.36816H12.3332H15.6665V7.86816H2.33317V5.36816H5.6665ZM2.33325 14.5352V9.53516H7.33325V11.2018H10.6666V9.53516H15.6666L15.6674 14.5352H2.33325Z",
    fill: "#6A7187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarFaBriefcase);
export default __webpack_public_path__ + "static/media/far_fa-briefcase.e82f9bac.svg";
export { ForwardRef as ReactComponent };